import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { AnimatedSwitch } from "react-router-transition";
import { db } from "./firebaseConfig";

import Home from "./Home";
import Table from "./Table";
import SignUp from "./SignUp";

function App() {
  const [allMembers, setAllMembers] = useState([]);

  useEffect(() => {
    const getMembers = async () => {
      await db.collection("members").onSnapshot((snapshot) => {
        setAllMembers(snapshot.docs.map((doc) => doc.data()));
      });
    };
    getMembers();
  }, []);

  return (
    <Router>
      <AnimatedSwitch
        atEnter={{ opacity: 0 }}
        atLeave={{ opacity: 0 }}
        atActive={{ opacity: 1 }}
        className="switch-wrapper"
      >
        <Route exact path="/" component={Home} />
        <Route exact path="/list">
          <Table allMembers={allMembers} />
        </Route>
        <Route exact path="/signup">
          <SignUp allMembers={allMembers} />
        </Route>
      </AnimatedSwitch>
    </Router>
  );
}

export default App;
